// 館内プリント可能アイテム
export const ndlPrintItemList: Array<string> = [
  'internet',
  'internet_no_download',
  'internet_print_ndl_only',
  'ooc',
  'ooc_no_snippet',
  'ndl_only',
  'ndl_only_no_snippet',
  'ndl_only_package',
  'ndl_only_no_simview',
  'shinsai_internet',
  'shinsai_ndl_only'
]
// 個人送信プリント可能アイテム
export const kojinsoushinPrintItemList: Array<string> = [
  'internet',
  'internet_no_download',
  'ooc',
  'ooc_no_snippet',
]
